<template>
    <div>
      <design-opposition-list></design-opposition-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  